import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type CreateMaterial = ClientInferResponseBody<typeof contract.materials.createMaterial, 201>;

export type CreateMaterialDto = ClientInferRequest<
  typeof contract.materials.createMaterial
>["body"];

export const createMaterial = async (body: CreateMaterialDto): Promise<CreateMaterial> => {
  const response = await api.materials.createMaterial.mutation({
    body,
  });

  if (response.status === 201) {
    return response.body;
  }

  throw new ApiError("Failed to create material", response.status, response.body);
};
